// MUI theme carrying the MySM brand palette.
//
// The app has no app-wide MUI ThemeProvider, so MUI components fall back to
// MUI's default blue (#1976d2) while styled-components use COLORS.PRIMARY
// (#2B4B81). Wrap a page in <ThemeProvider theme={brandMuiTheme}> to align
// its MUI controls (buttons, focus rings, progress, checkboxes) with the
// brand navy. Only `primary` is overridden; every other palette entry
// (warning, error, …) keeps MUI's defaults.
//
// Scoped per page for now (Bench Candidates first); applying it app-wide is a
// separate decision because it restyles every MUI control in the app.

import { createTheme } from '@mui/material/styles';
import { COLORS } from '../constants/radar';

const brandMuiTheme = createTheme({
  palette: {
    primary: {
      main: COLORS.PRIMARY,
      contrastText: COLORS.WHITE,
    },
  },
});

export default brandMuiTheme;
